import React from 'react';

const Location = () => {
    return (
        <div>
            
        </div>
    );
};

export default Location;